import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modal: {
    [theme.breakpoints.down('sm')]: {
      overflowY: 'auto'
    }
  },
  deletePaper: {
    backgroundColor: theme.palette.background.default,
    margin: 'auto',
    width: '60%',
    minWidth: 500,
    padding: '15px 10px',
    marginTop: '15vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    [theme.breakpoints.down('xs')]: {
      width: '90%',
      minWidth: 'unset',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  }
}))

export default useStyles
